<template>
	<div>
		<notifications></notifications>
		<div :class="{'nav-open': $sidebar.showSidebar}">
			<router-view v-if="$store.state.authentication.loggedIn"></router-view>
			<login v-if="!$store.state.authentication.loggedIn"></login>
		</div>

	</div>
</template>

<script>
	import Login from '@/pages/Login.vue'
	export default {
		components: {
			Login
		},
		data() {
			return {
				default: null
			}
		},
		created() {
			console.log()
		}
	}
</script>
<style>
	.md-textarea {
		min-height: 400px !important;
	}

	.md-list-item-text {
		line-height: 48px !important;
		padding: 0px 18px !important;
	}

	.el-tabs__item.is-active {
		color: #3c79b7 !important;
	}

	.el-tabs__item:hover {
		color: #3c79b7 !important;
	}

	.el-tabs__active-bar {
		background-color: #3c79b7 !important;
	}

	.md-progress-bar-fill {
		background-color: #3c79b7 !important;
	}

	.md-progress-bar {
		background-color: #3c7ab736 !important;
	}

	.md-title {
		letter-spacing: 0 !important;
	}

	.active {
		background-color: #55efc4;
		border-radius: 5px;
		padding: 2px 8px;
	}
	.neutral {
		background-color: #3c79b7;
		border-radius: 5px;
		padding: 2px 8px;
	}

	.late {
		background-color: #fab1a0;
		border-radius: 5px;
		padding: 2px 8px;
	}

	.warn {
		background-color: #f39c12;
		border-radius: 5px;
		padding: 2px 8px;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.md-list-item-text {
		font-family: "Nunito", "Dangrek";
	}

	.vdatetime {
		width: 100%;
	}
	.md-radio.md-theme-default.md-checked.md-primary .md-radio-container:after {
		background-color: #3c79b7 !important;
	}
	.md-radio.md-theme-default.md-checked.md-primary .md-radio-container {
		border-color: #3c79b7 !important;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue